import { RefObject, useCallback } from 'react';
import scrollToRef from '@ahmdigital/logic/lib/utils/scroll-to-ref';

import useIntersectionObserver from '../../../../hooks/use-intersection-observer';

const useScrollToRefIfOutOfView = (ref: RefObject<Element>) => {
  const { entry } = useIntersectionObserver(ref);

  return useCallback(() => {
    if (entry && !entry.isIntersecting) {
      scrollToRef(ref, { behavior: 'smooth' });
    }
  }, [entry, ref]);
};

export default useScrollToRefIfOutOfView;
